<template>
  <div class="app">
    <Header v-bind:isLoggedIn="isLoggedIn" />
    <slot />
    <Footer />
  </div>
</template>
<script>
import Header from "@/layout/partials/Header.vue";
import Footer from "@/layout/partials/Footer.vue";

export default {
  name: "Default-Layout",
  props: ["isLoggedIn"],
  components: {
    Header,
    Footer,
  },
  data() {
    return {};
  },
  computed: {},
  methods: {},
};
</script>
